import type { QueryClient } from "@tanstack/react-query"
import { createFileRoute, redirect } from "@tanstack/react-router"
import { userQueryOptions } from "@/entities/user"
import { getOnboardingFormValues } from "@/features/registration-workflow"
import { SignupEmailVerificationPage } from "@/pages/onboarding"

interface SignupEmailVerificationSearch {
	email?: string | undefined
}

export const Route = createFileRoute("/onboarding/signup-email-verification")({
	component: SignupEmailVerificationPage,
	validateSearch: (search): SignupEmailVerificationSearch => ({
		email: typeof search.email === "string" ? search.email : undefined,
	}),
	beforeLoad: async ({ context, search }) => {
		const accountEmail = await emailOf(context.queryClient, context.userId)
		const email =
			search.email ?? getOnboardingFormValues()?.email ?? accountEmail
		if (!email) throw redirect({ to: "/onboarding/signup-email" })
	},
})

async function emailOf(
	queryClient: QueryClient,
	userId: number | null,
): Promise<string | null> {
	if (userId === null) return null
	const user = await queryClient.query({
		...userQueryOptions(userId),
		staleTime: "static",
	})
	return user.email
}
